module.exports = __webpack_public_path__ + "static/media/carpediemWithMap.c412cc24.svg";